<template>
    <li class="hiq-calendar__event">
        <a class="hiq-calendar__event--link" :href="event.url">
            <div class="hiq-calendar__event--header-wrapper">
                <div class="hiq-calendar__event--image" v-html="event.image"></div>
                <h3 class="hiq-calendar__event--heading">{{event.title}}</h3>
            </div>
            <div class="hiq-calendar__event--content">
                <p class="hiq-calendar__event--description">{{event.description}}</p>
                <div class="hiq-calendar__event--info">
                    <p class="hiq-p hiq-calendar__event--info__date" v-if="event.date">
                        <span class="show-for-sr">{{translations.date}}:</span>
                        {{event.dateAndTime}}
                    </p>
                    <p class="hiq-p hiq-calendar__event--info__location" v-if="event.location">
                        <span class="show-for-sr">{{translations.location}}</span>
                        {{event.location}}
                    </p>
                    <p class="hiq-p hiq-calendar__event--info__categories" v-if="event.categories && event.categories.length > 0">
                        <span class="show-for-sr">{{translations.categories}}:</span>
                        {{event.categories.join(', ')}}
                    </p>
                </div>
            </div>
        </a>
    </li>
</template>
<script>
import Vue from 'vue';
export default Vue.extend({
    name: 'event',
    props: {
        event: {}
    },
    computed: {
        translations() {
            return this.$store.state.translations;
        }
    }
})
</script>